import { Box } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Text from "../text/Text";
import { enable2FA } from "../messages";
import { twoStepVerificationIcon } from "../images";

function VerifyMFABar({ navigate }) {
  return (
    <Box
      className="verify-mfa-bar"
      onClick={() => navigate("/settings/two-step-verification")}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <img
          src={twoStepVerificationIcon}
          height={20}
          width={20}
          alt="verify 2FA icon"
        />
        <Text className="default-text" size={16} font="semibold">
          {enable2FA}
        </Text>
      </Box>
      <KeyboardArrowRightIcon sx={{ color: "#041F61" }} />
    </Box>
  );
}

export default VerifyMFABar;
